import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import Russian translations
import ruHeader from "../locales/ru/header.json";
import ruRouteList from "../locales/ru/routeList.json";
import ruPaymentPage from "../locales/ru/paymentPage.json";
import ruFooter from "../locales/ru/footer.json";
import ruPrinting from "../locales/ru/printing.json";
import ruPrices from "../locales/ru/prices.json";
import ruAdvertisement from "../locales/ru/advertisement.json";
import ruTopUsers from "../locales/ru/topUsers.json";
import ruVerifyUser from "../locales/ru/verifyUser.json";
import ruListDoc from "../locales/ru/listDoc.json";
import ruDocItems from "../locales/ru/docItems.json";
import ruEditDoc from "../locales/ru/editDoc.json";
import ruLanguage from "../locales/ru/language.json";
import ruInactivityModal from "../locales/ru/inactivityModal.json";
import rufileView from "../locales/ru/fileView.json";
import ruEditManyDocs from "../locales/ru/editManyDocs.json";
import ruNewFeatures from "../locales/ru/newFeatures.json";

// Import English translations
import enHeader from "../locales/en/header.json";
import enRouteList from "../locales/en/routeList.json";
import enPaymentPage from "../locales/en/paymentPage.json";
import enFooter from "../locales/en/footer.json";
import enPrinting from "../locales/en/printing.json";
import enPrices from "../locales/en/prices.json";
import enAdvertisement from "../locales/en/advertisement.json";
import enTopUsers from "../locales/en/topUsers.json";
import enVerifyUser from "../locales/en/verifyUser.json";
import enListDoc from "../locales/en/listDoc.json";
import enDocItems from "../locales/en/docItems.json";
import enEditDoc from "../locales/en/editDoc.json";
import enLanguage from "../locales/en/language.json";
import enInactivityModal from "../locales/en/inactivityModal.json";
import enfileView from "../locales/en/fileView.json";
import enEditManyDocs from "../locales/en/editManyDocs.json";
import enNewFeatures from "../locales/en/newFeatures.json";

// Import Kazakh translations
import kzHeader from "../locales/kz/header.json";
import kzRouteList from "../locales/kz/routeList.json";
import kzPaymentPage from "../locales/kz/paymentPage.json";
import kzFooter from "../locales/kz/footer.json";
import kzPrinting from "../locales/kz/printing.json";
import kzPrices from "../locales/kz/prices.json";
import kzAdvertisement from "../locales/kz/advertisement.json";
import kzTopUsers from "../locales/kz/topUsers.json";
import kzVerifyUser from "../locales/kz/verifyUser.json";
import kzListDoc from "../locales/kz/listDoc.json";
import kzDocItems from "../locales/kz/docItems.json";
import kzEditDoc from "../locales/kz/editDoc.json";
import kzLanguage from "../locales/kz/language.json";
import kzInactivityModal from "../locales/kz/inactivityModal.json";
import kzfileView from "../locales/kz/fileView.json";
import kzEditManyDocs from "../locales/kz/editManyDocs.json";
import kzNewFeatures from "../locales/kz/newFeatures.json";

const resources = {
    ru: {
        translation: {
            header: ruHeader,
            routeList: ruRouteList,
            paymentPage: ruPaymentPage,
            footer: ruFooter,
            printing: ruPrinting,
            prices: ruPrices,
            advertisement: ruAdvertisement,
            top_users: ruTopUsers,
            verifyUser: ruVerifyUser,
            listDoc: ruListDoc,
            docItems: ruDocItems,
            editDoc: ruEditDoc,
            language: ruLanguage,
            inactivityModal: ruInactivityModal,
            fileView: rufileView,
            editManyDocs: ruEditManyDocs,
            newFeatures: ruNewFeatures
        },
    },
    en: {
        translation: {
            header: enHeader,
            routeList: enRouteList,
            paymentPage: enPaymentPage,
            footer: enFooter,
            printing: enPrinting,
            prices: enPrices,
            advertisement: enAdvertisement,
            top_users: enTopUsers,
            verifyUser: enVerifyUser,
            listDoc: enListDoc,
            docItems: enDocItems,
            editDoc: enEditDoc,
            language: enLanguage,
            inactivityModal: enInactivityModal,
            fileView: enfileView,
            editManyDocs: enEditManyDocs,
            newFeatures: enNewFeatures
        },
    },
    kk: {
        translation: {
            header: kzHeader,
            routeList: kzRouteList,
            paymentPage: kzPaymentPage,
            footer: kzFooter,
            printing: kzPrinting,
            prices: kzPrices,
            advertisement: kzAdvertisement,
            top_users: kzTopUsers,
            verifyUser: kzVerifyUser,
            listDoc: kzListDoc,
            docItems: kzDocItems,
            editDoc: kzEditDoc,
            language: kzLanguage,
            inactivityModal: kzInactivityModal,
            fileView: kzfileView,
            editManyDocs: kzEditManyDocs,
            newFeatures: kzNewFeatures
        },
    },
};

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        // lng не задаём явно: если задать, i18next-browser-languagedetector
        // полностью отключается (см. его доки), и после любой полной перезагрузки
        // страницы (например, "refresh-page" от Electron) язык всегда сбрасывался
        // бы на захардкоженное значение, а не на тот, что реально выбрал
        // пользователь. fallbackLng — то, что покажется только при первом запуске,
        // пока в localStorage ещё нет i18nextLng.
        fallbackLng: "kk",
        detection: {
            // Без "navigator": на большинстве машин/киосков системная локаль — "ru",
            // и он почти всегда "успешно" определяется раньше, чем сработает
            // fallbackLng, из-за чего казахский по умолчанию никогда не показывался.
            // Теперь единственный источник — то, что пользователь реально выбрал
            // сам (сохраняется в localStorage при changeLanguage); если выбора ещё
            // не было, используется fallbackLng ("kk").
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
        interpolation: {
            escapeValue: false,
        },
        debug: true, // Включите отладку
    });

export default i18next;
